import { AdEnginePlugin } from "../../core/AdEnginePlugin";
import { EventSubscriber } from "../../helpers/eventSubscriber";

interface InContentPlayerPluginApi {
  initOnce: () => void;
  registerInContentPlayerInitCallback: (callback: () => void) => void;
}

/**
 * This plugin serves as a communication channel between application that injects the in-content player and the ad-engine
 *
 * It's the application responsibility to inject the in-content player's div element and use video-player repository to load the player assets.
 * But only ad-engine knows when a Fan Takeover appears on the page, so the application uses window.fandomAds to register the init callback
 * and ad-engine will execute it once it knows there is no Fan Takeover nor featured video on the page.
 *
 * @see {TopStrategyTunerPlugin.handleInContentVideo}
 */
export class InContentPlayerPlugin extends AdEnginePlugin<InContentPlayerPluginApi> {
  /**
   * This flag is set to true once we execute inContentVideoInitCallback and therefore load the video player in the page content
   * @private
   */
  private hasFiredInContentVideoInitCallback = false;
  /**
   * Event subscriber that is fired when we're sure that there is no Fan Takeover ad on the page and there is no primary video.
   * @see {TopStrategyTunerPlugin.handleInContentVideo}
   */
  private readonly initOnceEventSubscriber = new EventSubscriber(1);

  api = {
    initOnce: () => {
      if (!this.hasFiredInContentVideoInitCallback) {
        this.hasFiredInContentVideoInitCallback = true;

        this.initOnceEventSubscriber.notify();
      }
    },
    /**
     * Registers callback only if there is no Fan Takeover ad on the page and there is no primary video
     */
    registerInContentPlayerInitCallback: (callback: () => void) => {
      this.initOnceEventSubscriber.subscribe(callback);
    },
  };
}
